import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { WallboardViewService } from '../wallboard-view.service';
import { WallboardsService } from '../../wallboards.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { spotlightDataObj, WVData, WVMain } from '../wallboard-view.model';
import { SpotlightSetupObj, ModuleType } from '../../wallboards.model';

@Component({
    selector: 'cv-wallboard-view-spotlight',
    templateUrl: './wallboard-view-spotlight.component.html',
    styleUrls: ['./wallboard-view-spotlight.component.scss']
})
export class WallboardViewSpotlightComponent implements OnInit, OnDestroy {
    @Input() firstSlide: boolean;

    @ViewChild('wallboardViewSlide') slideContainer: ElementRef<HTMLElement>;

    public wvf: WVMain = null;
    public wvsf: WVData = null;
    public spotlightState: SpotlightSetupObj = null;
    public spotlightData: spotlightDataObj = null;

    public showType = 0; // 1 = Bio, 2 = Hobby, 3 = Badges
    public badgeHeight = 0;
    public badgeWidth = 0;
    public imgHeight = 0;
    public imgWidth = 0;
    public badgeDimension: boolean;
    public localization: Map<string, string>;

    private isDestroyed: boolean = false;
    private _hasBackdrop: boolean = false;
    private _moduleKey: string = "";
    private _backgroundID: number = 0;

    get hasBackdrop(): boolean {
        return this._hasBackdrop;
    }

    get moduleKey(): string {
        return this._moduleKey;
    }

    get backgroundID(): number {
        return this._backgroundID;
    }

    get hobbiesLabel(): string {
        return this.localization?.get("Hobbies") ?? "Hobbies";
    }

    get badgesLabel(): string {
        return this.localization?.get("Latest_Badges_Earned") ?? "Latest Badges Earned";
    }

    /*get imgHeight() {
        return $('.spotlightImageHolder').height();
    }

    get imgWidth() {
        return $('.spotlightImageHolder').width();
    }*/

    get slideElement(): JQuery<HTMLElement> {
        return $(this.slideContainer.nativeElement);
    }

    constructor(
        private service: WallboardViewService,
        public wallboardsService: WallboardsService,
        private cvLocalizationFactory: CVLocalizationService,
    ) { }
 
    ngOnInit(): void {
        this.wvf = this.service.WVMain;
        this.wvsf = this.service.WVSpotlight;

        this._hasBackdrop = this.wvsf?.Slide.HasBackdrop ?? false;
        this._moduleKey = this.wvsf?.Slide.WallboardModuleDetails[0].WallboardModuleKey ?? "";
        this._backgroundID = this.wvsf?.Slide.BackgroundImageID ?? 0;

        this.cvLocalizationFactory.GetSection("Wallboard_Management").then(response => {
            this.localization = response;
        });

        this.wvf.RunSlide = this.firstSlide;

        this.loadTypeState().then(response => {
            if (this.isDestroyed)
                return;

            this.spotlightState = response.Spotlight_Setup;

            this.getSpotlightModuleData().then(response => {
                if (this.isDestroyed)
                    return;

                this.spotlightData = response;

                if (this.spotlightData?.UserProfile?.Bio.length > 297)
                    this.spotlightData.Bio = this.spotlightData.UserProfile.Bio.substr(0, 297) + "...";

                if (this.firstSlide)
                    this.wvf.FirstSlideReady = true;
                else
                    this.wvf.NextSlideReady = true;

                this.runSlide();
            });
        });
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
    }

    public async loadTypeState() {
        let latestError;

        for (let i = 0; i < 3; i++) {
            try {
                return await this.wallboardsService.loadTypeState(ModuleType.Spotlight, this.moduleKey, this.wvf.WallboardCreatorID);
            }
            catch (error) {
                latestError = error;
            }
        }

        this.wvf.SkipNextSlide = true;

        throw latestError;
    }

    public async getSpotlightModuleData() {
        let latestError;

        for (let i = 0; i < 3; i++) {
            try {
                return await this.service.getSpotlightModuleData(this.wvf.WallboardCreatorID, this.spotlightState.LoginID, this.spotlightState.ShowBadges, this.spotlightState.ShowBadgeCount, this.moduleKey);
            }
            catch (error) {
                latestError = error;
            }
        }

        this.wvf.SkipNextSlide = true;

        throw latestError;
    }

    public runSlide() {
        if (this.wvf.RunSlide)
            this.runInnerTransitions();
        else {
            setTimeout(() => {
                this.runSlide();
            }, 1000);
        }
    }

    public runInnerTransitions() {
        let textPieces = 0;
        if (this.spotlightState.ShowBio)
            textPieces++;
        if (this.spotlightState.ShowHobbies)
            textPieces++;
        if (this.spotlightState.ShowBadges)
            textPieces++;

        if (this.showType == 0) { // Set initial showType
            if (this.spotlightState.ShowBio)
                this.showType = 1;
            else if (this.spotlightState.ShowHobbies)
                this.showType = 2;
            else if (this.spotlightState.ShowBadges)
                this.showType = 3;
            else
                this.showType = 4;
        }

        if (this.showType == 1) {
            setTimeout(() => {
                this.sizeBioText();
            }, 0);

            setTimeout(() => {
                this.transitionBio();
            }, 0);
        }

        if (this.showType == 2) {
            setTimeout(() => {
                this.transitionHobbies();
            }, 0);
        }

        if (this.showType == 3) {
            setTimeout(() => {
                let databox = $(".dataBox[mid=" + this.moduleKey + "]:last");
                let badgeContainer = $(".badgeContainer[mid=" + this.moduleKey + "]:last");
                let badgeHolder = $(".badgeHolder[mid=" + this.moduleKey + "]:last");

                if (this.spotlightState.ShowBadgeCount == 1) {
                    this.badgeHeight = Math.floor(((databox.height() - ($(window).height() * .052 + 114)) / (badgeContainer.children().length - 1)) * .8);
                    this.badgeWidth = Math.floor(databox.width() / (badgeHolder.children().length));
                    this.badgeDimension = !(this.badgeWidth > (this.badgeHeight * .8333)); //true = height auto, false = width auto 
                }
                else if (this.spotlightState.ShowBadgeCount == 3) {
                    this.badgeHeight = Math.floor((databox.height() - ($(window).height() * .052 + 205)) / (badgeContainer.children().length - 1) * .7);
                    this.badgeWidth = Math.floor(((databox.width() - 40) / (badgeHolder.children().length)) * .7);
                    this.badgeDimension = !(this.badgeWidth > (this.badgeHeight * .8333)); //true = height auto, false = width auto
                }
                else {
                    this.badgeHeight = Math.floor((databox.height() - ($(window).height() * .052 + 205)) / (badgeContainer.children().length - 1));
                    this.badgeWidth = Math.floor((databox.width() - 40) / (badgeHolder.children().length));
                    this.badgeDimension = !(this.badgeWidth > (this.badgeHeight * .8333)); //true = height auto, false = width auto
                }

                setTimeout(() => {
                    this.transitionBadges();
                }, 0);
            }, 0);
        }

        setTimeout(() => {
            if (this.showType == 1) {
                if (this.spotlightState.ShowHobbies) {
                    this.showType = 2;
                    this.runInnerTransitions();
                }
                else if (this.spotlightState.ShowBadges) {
                    this.showType = 3;
                    this.runInnerTransitions();
                }
            }
            else if (this.showType == 2) {
                if (this.spotlightState.ShowBadges) {
                    this.showType = 3;
                    this.runInnerTransitions();
                }
            }
        }, (((this.wvf.Slides[this.wvf.CurrentSlide].SlideInterval - 1) * 1000) / textPieces));

        setTimeout(() => {
            if (this.showType == 1) {
                if (this.spotlightState.UseProfileBio) {
                    let profileBio = $(".profileBio[mid=" + this.moduleKey + "]:last");
                    let hobbyHeading = $(".hobbyHeading[mid=" + this.moduleKey + "]:last");

                    profileBio.fadeOut(1000);
                    hobbyHeading.fadeIn(1000);
                }
                else {
                    let otherBio = $(".otherBio[mid=" + this.moduleKey + "]:last");

                    otherBio.fadeOut(1000);
                }
            }
            else if (this.showType == 2) {
                let hobbyHeading = $(".hobbyHeading[mid=" + this.moduleKey + "]:last");
                let hobbyTable = $(".hobbyTable[mid=" + this.moduleKey + "]:last");

                hobbyHeading.fadeOut(1000);
                hobbyTable.fadeOut(1000);
            }

        }, (((this.wvf.Slides[this.wvf.CurrentSlide].SlideInterval - 1) * 1000) / textPieces) - 1000);
    }

    public transitionBio() {
        if (this.spotlightState.UseProfileBio) {
            let profileBio = $(".profileBio[mid=" + this.moduleKey + "]:last");
            profileBio.css("right", "0%");
        }
        else {
            let otherBio = $(".otherBio[mid=" + this.moduleKey + "]:last");
            otherBio.css("right", "0%");
        }
    }

    public transitionHobbies() {
        let hobbyHeading = $(".hobbyHeading[mid=" + this.moduleKey + "]:last");

        hobbyHeading.fadeIn(500);

        for (let i = 0; i < this.spotlightState.HobbyList.length; i++) {
            //$("#hobbyTable" + this.moduleKey).find(".hobbyItem" + i).fadeIn(500 * (i + 1));
            setTimeout(() => {
                let hobbyTable = $(".hobbyTable[mid=" + this.moduleKey + "]:last");

                hobbyTable.find(".hobbyItem" + i).fadeIn(500);
            }, 400 * i, true, i);
        }
    }

    public transitionBadges() {
        let badgeHeading = $(".badgeHeading[mid=" + this.moduleKey + "]:last");

        badgeHeading.fadeIn(500);

        if (this.spotlightState.ShowBadgeCount == 1) {
            let badgeContainer = $(".badgeContainer[mid=" + this.moduleKey + "]:last");

            badgeContainer.find(".badgeItem1").css("transform", "rotateY(0deg)");
        }
        else if (this.spotlightState.ShowBadgeCount == 3) {
            for (let i = 1; i < 4; i++) {
                setTimeout(() => {
                    let badgeContainer = $(".badgeContainer[mid=" + this.moduleKey + "]:last");

                    badgeContainer.find(".badgeItem" + i).css("transform", "rotateY(0deg)");
                }, 250 * i, true, i);
            }
        }
        else if (this.spotlightState.ShowBadgeCount == 6) {
            for (let i = 1; i < 7; i++) {
                setTimeout(() => {
                    let badgeContainer = $(".badgeContainer[mid=" + this.moduleKey + "]:last");

                    badgeContainer.find(".badgeItem" + i).css("transform", "rotateY(0deg)");
                }, 250 * i, true, i);
            }
        }
    }

    public getBadgeID(id) {
        if (!this.spotlightData?.Badges)
            return -25;

        if (this.spotlightData.Badges.length >= id)
            return this.spotlightData.Badges[id - 1].ImageID;
        else
            return -25;
    }

    public getBadgeLevelName(id) {
        if (!this.spotlightData?.Badges)
            return "";

        if (this.spotlightData.Badges.length >= id)
            return this.spotlightData.Badges[id - 1].BadgeLevelName;
        else
            return "";
    }

    /**
     * Returns the image URL for the badge with the given ID.
     * @param id Badge ID
     * @returns
     */
    public getBadgeImage(id) {
        return `../Admin/ImageResizer.aspx?imgid=${this.getBadgeID(id)}&w=${this.badgeDimension ? this.badgeWidth : 'auto'}&h=${!this.badgeDimension ? this.badgeHeight : 'auto'}`;
    }

    public sizeBioText() {
        let divElem: JQuery<HTMLElement>;

        if (this.spotlightState.UseProfileBio) {
            let profileBio = $(".profileBio[mid=" + this.moduleKey + "]:last");

            divElem = profileBio;
        }
        else {
            let otherBio = $(".otherBio[mid=" + this.moduleKey + "]:last");

            divElem = otherBio;
        }

        let divMax = divElem.parent().height();
        let divMaxWidth = divElem.parent().width();
        let divSize = divElem.height();
        let divWidth = divElem.width();

        divElem.css('visibility', 'hidden');

        while (divSize < divMax && divWidth <= divMaxWidth && (+divElem.css('font-size').slice(0, -2) - 0) < 50) {
            divElem.css('font-size', +divElem.css('font-size').slice(0, -2) - 0 + 5 + 'px');
            divSize = divElem.height();
            divWidth = divElem.width();

            if (divSize == 0)
                return;
        }

        while (divSize > divMax || divWidth > divMaxWidth) {
            divElem.css('font-size', +divElem.css('font-size').slice(0, -2) - 1 + 'px');
            divSize = divElem.height();
            divWidth = divElem.width();
        }

        divElem.css('visibility', 'visible');
    }

    public getBioText(isBio: boolean) {
        if (isBio) {
            if (this.spotlightData?.UserProfile) {
                if (this.spotlightData.UserProfile.Bio.length > 497)
                    return this.spotlightData.UserProfile.Bio.substr(0, 497) + "...";
                else
                    return this.spotlightData.UserProfile.Bio;
            }
            else
                return "";
        }
        else if (this.spotlightState.BioString.length > 497)
            return this.spotlightState.BioString.substr(0, 497) + "...";
        else
            return this.spotlightState.BioString;
    }

    public getImage() {
        if (this.spotlightData) {
            this.imgHeight = $('.spotlightImageHolder').height();
            this.imgWidth = $('.spotlightImageHolder').width();
            let size = this.imgHeight > this.imgWidth ? this.imgWidth : this.imgHeight;

            this.imgHeight = size;
            this.imgWidth = size;

            $('#spotlightImg' + this.moduleKey).css("height", size);
            $('#spotlightImg' + this.moduleKey).css("width", size);

            if (this.spotlightData.useAvatar)
                //return "url(../Admin/AvatarProfileImage.aspx?loginid=" + this.spotlightData.imgID + "&w=" + size +"&h=" + size + ")";
                return `url(../Admin/AvatarImage.aspx?previewID=${this.spotlightData.imgID})`;
            else
                return `url(../Admin/ImageResizer.aspx?imgid=${this.spotlightData.imgID || '-2'}&w=${size}&h=${size})`;
        }
    }
}
